import {
  Box,
  Disclaimer,
  Div,
  formatDateTimeShort,
  SystemProblem,
} from '@vgrubs/components';
import {
  problemTypeLabel,
  problemWhereLabel,
} from '../helpers/systemProblemLabels';
import { InPlaceActions, ProblemActionButton } from './ProblemActionButton';
import { RowTitle } from './SystemProblemRow.styled';
import { SystemProblemPill } from './SystemProblemPill';

type Props = {
  problem: SystemProblem;
  onOpen: (problemId: number) => void;
  /** The restaurant's phone, for the "Call restaurant" types. */
  phone?: string | null;
  inPlace?: InPlaceActions;
};

/**
 * One problem in the list: what it is, where, who caused it, when, the pill
 * that says how urgent it is (or that it is resolved), and while it is open
 * the one thing to do about it.
 */
export const SystemProblemRow = ({
  problem,
  onOpen,
  phone,
  inPlace,
}: Props) => (
  <Box $mb="8" $pointer onClick={() => onOpen(problem.id)}>
    <Div
      $flex
      $between
      $alignCenter
      $gap="16px"
      $gapSM="8px"
      $columnSM
      $alignStartSM
    >
      {/* Full width once it stacks, or the title has nothing to ellipse
          against - see SupportTicketRow. */}
      <Div $flex $column $gap="4px" $widthSM="100%" style={{ minWidth: 0 }}>
        <Div $flex $alignCenter $gap="8px">
          <Disclaimer $m="0">#{problem.id}</Disclaimer>
          <Disclaimer $m="0">{problemTypeLabel(problem.type)}</Disclaimer>
        </Div>

        <RowTitle>{problem.title}</RowTitle>

        <Disclaimer $m="0">{problemWhereLabel(problem)}</Disclaimer>
      </Div>

      <Div $flex $alignCenter $gap="12px" $flexNone>
        <Disclaimer $m="0">{formatDateTimeShort(problem.createdAt)}</Disclaimer>
        <SystemProblemPill problem={problem} />
        {problem.status === 'open' && (
          <ProblemActionButton
            problem={problem}
            phone={phone}
            inPlace={inPlace}
          />
        )}
      </Div>
    </Div>
  </Box>
);
